import { render, staticRenderFns } from "./ProjectViewTeamIndex.vue?vue&type=template&id=01a03950&"
import script from "./ProjectViewTeamIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectViewTeamIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports